export const environment = {
   production: true,
   keys: {
      gmap: 'GoogleMapsApiKeyGoesHere'
   }
};
